import {Injectable} from '@angular/core';
//import {Http, ResponseContentType} from '@angular/http';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FileService {

  constructor(private http: HttpClient) {}

//downloadFile(): Observable<any> {
		//return this.http.get('http://localhost:8080/employees/download', {responseType: ResponseContentType.Blob});
  downloadFile(parafilename): any {
		return this.http.get(parafilename, {responseType: 'blob'}).pipe( retry(1),

        catchError(this.handleError)
   
      );
  } 
  handleError(error) {

    let errorMessage = '';
 
    if (error.error instanceof ErrorEvent) {
 
      // client-side error
 
      errorMessage = error.message;
 
    } else {
 
      // server-side error
 
      errorMessage = 'File Not Found !!!';//error.message;
 
    }
 
    window.alert(errorMessage);
 
    return throwError(errorMessage);
 
  }
   
}